import { useCallback } from "react";

import { useSdk } from "hooks/useSdk";
import withAuthentication from "hooks/withAuth";

const useReadMessage = () => {
  const sdk = useSdk();

  /**
   * メッセージの既読
   */
  const readMessage = useCallback(
    async ({ applicationId }: { applicationId: string }) => {
      return await withAuthentication(async (idToken) => {
        const res = await sdk(idToken)
          .readMessage({
            applicationId,
          })
          .catch((e) => {
            throw new Error(e);
          });
        if (res.messageRead.userErrors && res.messageRead.userErrors?.length > 0) {
          console.error(res.messageRead.userErrors);
          throw new Error("失敗しました");
        }
        return res;
      });
    },
    [sdk]
  );

  return {
    readMessage,
  };
};

export default useReadMessage;
